class Konami {
    constructor(attempt) {
        this.excepted = "";
        if (attempt === "konami") {
            this.excepted = "38384040373937396665"
        } else {
            for (let l in attempt) {
                this.excepted += attempt.toUpperCase().charCodeAt(l);
            }
        }
        this.konami = "";
        this.observers = [];
        this.create();
    }
    create() {
        window.addEventListener("keydown", this.check.bind(this), true);
    }
    check(e) {
        this.konami += e.keyCode;
        this.dispatch(this.konami);
    }
    subscribe(f) {
        if (typeof f === "function")
            this.observers.push(f);
        else
            console.error(`attempt a function a receive a ${typeof f}`);
    }
    unsubscribe(f) {
        this.observers = this.observers.filter(subscriber => subscriber !== f);
    }
    dispatch(data) {
        if (this.konami !== this.excepted.slice(0, this.konami.length)) {
            this.observers.forEach(observer => observer({
                status: 406,
                konami: data
            }));
            this.konami = "";
        } else {
            this.observers.forEach(observer => observer({
                status: 202,
                konami: { progress: (data.length / this.excepted.length), value: data }
            }));
        }
        if (this.konami === this.excepted) {
            this.konami = "";
            this.observers.forEach(observer => observer({
                status: 200,
                konami: data
            }));
        }
    }
    destroy() {
        window.removeEventListener("keyup", this.check.bind(this), true);
    }
}

/* TESTING ZONE */
/* const konamiChecker = new Konami("konami");
konamiChecker.subscribe(checking);

function checking(e) {
    if (e.status === 200) {
        alert('KONAMI');
    }
}

const bigeChecker = new Konami("bige");
bigeChecker.subscribe(checkingBige);

function checkingBige(e) {
    if (e.status === 200) {
        alert('BIGE');
    }
} */

export { Konami };
